import VXEStore from './store'

const menus = new VXEStore()

export default menus
